import {
  IsUUID,
  IsString,
  IsOptional,
  IsNumber,
  ValidateNested,
  Min,
  IsEnum,
  IsArray,
} from 'class-validator';
import { Type } from 'class-transformer';

import {
  MonitoringsResponseInterface,
  MonitoringAttachmentsResponseInterface,
  MonitoringAttachmentsStatus,
  MonitoringStatus,
} from '../../interface/monitorings/monitorings-response.interface';

import { MiniUsersDto } from '../users/users.dto';
import { CompanyDto } from '../companies/company.dto';
import { ProposalsDto } from '../proposals/proposals.dto';
import { AttachmentsDto } from '../attachments/attachments.dto';
import { Brand, Industry, ProductCategory } from '../../utils/enums.utils';

export class MonitoringAttachmentsDto implements MonitoringAttachmentsResponseInterface {

  @IsUUID()
  monitoring_id!: string;

  @ValidateNested()
  @Type(() => AttachmentsDto)
  attachment!: AttachmentsDto;

  @IsEnum(MonitoringAttachmentsStatus)
  status!: MonitoringAttachmentsStatus;
}

export class MonitoringsDto implements MonitoringsResponseInterface {

  @IsUUID()
  id!: string;

  @IsEnum(MonitoringStatus)
  status!: MonitoringStatus;

  @IsString()
  category!: string;

  @IsOptional()
  @IsString()
  monitoring_remarks!: string | null;

  @IsOptional()
  @Type(() => Number)
  @IsNumber({ maxDecimalPlaces: 2 })
  buying_amount_vat_inc!: number | null;

  @IsOptional()
  @Type(() => Number)
  @IsNumber({ maxDecimalPlaces: 2 })
  selling_amount_vat_inc!: number | null;

  @IsOptional()
  @Type(() => Number)
  @IsNumber({ maxDecimalPlaces: 2 })
  estimated_gross_profit!: number | null;

  @IsOptional()
  @Type(() => Number)
  @IsNumber({ maxDecimalPlaces: 2 })
  mark_up!: number | null;

  @IsOptional()
  @Type(() => Number)
  @IsNumber({ maxDecimalPlaces: 2 })
  selling_amount_vat_ex!: number | null;

  @IsOptional()
  @IsString()
  project_code!: string | null;

  @IsEnum(Industry)
  industry!: Industry;

  @IsEnum(ProductCategory)
  product_category!: ProductCategory;

  @IsEnum(Brand)
  brand!: Brand;

  @IsOptional()
  @IsString()
  project_name!: string | null;

  @IsOptional()
  @IsString()
  created_at!: string | null;

  @IsOptional()
  @IsString()
  updated_at!: string | null;

  // Nested Proposal
  @ValidateNested()
  @Type(() => ProposalsDto)
  proposal!: ProposalsDto;

  // Nested Company
  @ValidateNested()
  @Type(() => CompanyDto)
  company!: CompanyDto;

  // Created / Updated By
  @IsOptional()
  @ValidateNested()
  @Type(() => MiniUsersDto)
  created_by!: MiniUsersDto | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => MiniUsersDto)
  updated_by!: MiniUsersDto | null;

  // Attachments array
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => MonitoringAttachmentsDto)
  attachments!: MonitoringAttachmentsDto[] | null;
}